module.exports = __webpack_public_path__ + "img/skinner-2-r.57dbb30d.png";